// @ts-strict-ignore
import {Component, ContentChild, ElementRef, Input, output} from "@angular/core";
import {MatDialogDataBaseInput} from "./basic-material-dialog.directive";
import {FontAwesomeCode} from "@models";

@Component({
	selector: "sim-basic-material-dialog",
	templateUrl: "./basic-material-dialog.component.html",
	styleUrls: ["./basic-material-dialog.component.scss"],
	standalone: false,
})
export class BasicMaterialDialogComponent {
	closeClicked = output<void>();
	@Input() matDialogData: MatDialogDataBaseInput;
	@Input() rect: DOMRect;
	@Input() finished: boolean;
	@Input() hideHeader: boolean = false;
	@Input() showActionDivider: boolean = true;
	@Input() headerIcon: FontAwesomeCode;
	@Input() headerText: string;
	@Input() showClosingX: boolean = true;
	@Input() smallHeader: boolean = false;
	@Input() overflowHandledByChild: boolean;

	@ContentChild("actionsWrapper") actionsWrapper: ElementRef;
}
